// Mutates project state. Kept in its own `.svelte.ts` module so the pure
// recipe encoder/decoder can be unit-tested without pulling the runes-backed
// project store into a Node test environment.

import type { RecipePayload } from '$lib/model/types';
import { projectStore } from '$lib/state/project.svelte';
import { bumpIdCounterAtLeast } from '$lib/model/tree';
import { triggerRecompute } from '$lib/compute/recompute.svelte';
import { maxStepIdNumber } from './recipe';

export function applyRecipe(payload: RecipePayload): void {
  projectStore.settings = payload.project_settings;
  projectStore.pipeline = payload.pipeline;
  projectStore.layer_order = payload.layer_order;

  const sel = projectStore.selected_step_id;
  if (!sel || !payload.pipeline.steps[sel]) {
    projectStore.selected_step_id = payload.pipeline.root_id;
  }

  bumpIdCounterAtLeast(maxStepIdNumber(payload.pipeline));
  triggerRecompute();
}
